export interface LangRoutesData {
  slug: string
  title: string
  description: string
}

interface RouteTranslations {
  [locale: string]: LangRoutesData
}

export const routesTranslations: Record<string, RouteTranslations> = {
  'home-page': {
    en: {
      slug: '',
      title: 'GOAT Gamesture',
      description: 'Become the GOAT! Join our community and unlock Exclusive Bonuses: Daily FREE energy, cashback (GCoins) on each purchase, unique store offers and more!'
    },
    pl: {
      slug: '',
      title: 'GOAT Gamesture',
      description: 'Zostań GOAT! Dołącz do naszej społeczności i odblokuj ekskluzywne bonusy: codzienną DARMOWĄ energię, cashback (GCoins) za każdy zakup, unikalne oferty sklepowe i wiele więcej!'
    },
    de: {
      slug: '',
      title: 'GOAT Gamesture',
      description: 'Werde zum GOAT! Tritt unserer Community bei und schalte exklusive Boni frei: tägliche KOSTENLOSE Energie, Cashback (GCoins) bei jedem Kauf, einzigartige Shop-Angebote und mehr!'
    },
    fr: {
      slug: '',
      title: 'GOAT Gamesture',
      description: 'Devenez le GOAT ! Rejoignez notre communauté et débloquez des bonus exclusifs : énergie GRATUITE quotidienne, cashback (GCoins) sur chaque achat, offres uniques en boutique et plus encore !'
    },
    es: {
      slug: '',
      title: 'GOAT Gamesture',
      description: '¡Conviértete en el GOAT! Únete a nuestra comunidad y desbloquea bonos exclusivos: energía GRATIS diaria, cashback (GCoins) en cada compra, ofertas únicas en la tienda y más!'
    },
    pt: {
      slug: '',
      title: 'GOAT Gamesture',
      description: 'Torne-se o GOAT! Junte-se à nossa comunidade e desbloqueie bônus exclusivos: energia GRÁTIS diária, cashback (GCoins) em cada compra, ofertas únicas na loja e muito mais!'
    },
    zh: {
      slug: '',
      title: 'GOAT Gamesture',
      description: '成为GOAT！加入我们的社区，解锁专属奖励：每日免费能量、每次购买的返现（GCoins）、独特的商店优惠等！'
    },
    ru: {
      slug: '',
      title: 'GOAT Gamesture',
      description: 'Стань GOAT! Присоединяйся к нашему сообществу и открой эксклюзивные бонусы: ежедневная БЕСПЛАТНАЯ энергия, кэшбэк (GCoins) за каждую покупку, уникальные предложения в магазине и многое другое!'
    },
    it: {
      slug: '',
      title: 'GOAT Gamesture',
      description: 'Diventa il GOAT! Unisciti alla nostra community e sblocca bonus esclusivi: energia GRATUITA giornaliera, cashback (GCoins) su ogni acquisto, offerte uniche nel negozio e molto altro!'
    },
    ko: {
      slug: '',
      title: 'GOAT Gamesture',
      description: 'GOAT이 되어보세요! 우리 커뮤니티에 참여하고 독점 보너스를 잠금 해제하세요: 매일 무료 에너지, 매 구매마다 캐시백(GCoins), 독특한 스토어 혜택 등!'
    },
    ja: {
      slug: '',
      title: 'GOAT Gamesture',
      description: 'GOATになろう！コミュニティに参加して、独占ボーナスを解放しましょう：毎日の無料エネルギー、購入ごとのキャッシュバック（GCoins）、ユニークなストア特典など！'
    },
    cs: {
      slug: '',
      title: 'GOAT Gamesture',
      description: 'Staň se GOAT! Připoj se k naší komunitě a odemkni exkluzivní bonusy: denní ZDARMA energii, cashback (GCoiny) za každý nákup, jedinečné nabídky v obchodě a další!'
    },
    bg: {
      slug: '',
      title: 'GOAT Gamesture',
      description: 'Стани GOAT! Присъедини се към нашата общност и отключи ексклузивни бонуси: безплатна дневна енергия, кешбек (GCoins) за всяка покупка, уникални оферти в магазина и още!'
    },
    nl: {
      slug: '',
      title: 'GOAT Gamesture',
      description: 'Word de GOAT! Sluit je aan bij onze community en ontgrendel exclusieve bonussen: dagelijkse GRATIS energie, cashback (GCoins) bij elke aankoop, unieke winkelaanbiedingen en meer!'
    }
  },
  'how-to-delete-my-data-page': {
    en: {
      slug: 'how-to-delete-my-data',
      title: 'How to Delete My Data - GOAT Gamesture',
      description: 'How to request the deletion of your personal data processed by Gamesture'
    },
    pl: {
      slug: 'jak-usunac-moje-dane',
      title: 'Jak Usunąć Moje Dane - GOAT Gamesture',
      description: 'Jak złożyć wniosek o usunięcie Twoich danych osobowych przetwarzanych przez Gamesture'
    },
    de: {
      slug: 'wie-loesche-ich-meine-daten',
      title: 'Wie lösche ich meine Daten - GOAT Gamesture',
      description: 'So beantragen Sie die Löschung Ihrer von Gamesture verarbeiteten personenbezogenen Daten'
    },
    fr: {
      slug: 'comment-supprimer-mes-donnees',
      title: 'Comment supprimer mes données - GOAT Gamesture',
      description: 'Comment demander la suppression de vos données personnelles traitées par Gamesture'
    },
    es: {
      slug: 'como-eliminar-mis-datos',
      title: 'Como eliminar mis datos - GOAT Gamesture',
      description: 'Cómo solicitar la eliminación de tus datos personales procesados por Gamesture'
    },
    pt: {
      slug: 'como-eliminar-meus-dados',
      title: 'Como eliminar meus dados - GOAT Gamesture',
      description: 'Como solicitar a exclusão dos seus dados pessoais processados pela Gamesture'
    },
    zh: {
      slug: 'ru-he-shan-chu-wo-de-shu-ju',
      title: '如何删除我的数据 - GOAT Gamesture',
      description: '如何请求删除Gamesture处理的您的个人数据'
    },
    ru: {
      slug: 'kak-udalit-moi-dannye',
      title: 'Как удалить мои данные - GOAT Gamesture',
      description: 'Как запросить удаление ваших персональных данных, обрабатываемых Gamesture'
    },
    it: {
      slug: 'come-eliminare-i-miei-dati',
      title: 'Come eliminare i miei dati - GOAT Gamesture',
      description: 'Come richiedere la cancellazione dei tuoi dati personali trattati da Gamesture'
    },
    ko: {
      slug: 'nae-deiteo-sagjehaneun-bangbeob',
      title: '내 데이터 삭제 방법 - GOAT Gamesture',
      description: 'Gamesture가 처리하는 개인 데이터 삭제 요청 방법'
    },
    ja: {
      slug: 'watashi-no-deta-wo-sakujo-suru-houhou',
      title: 'データの削除方法 - GOAT Gamesture',
      description: 'Gamestureが処理する個人データの削除をリクエストする方法'
    },
    cs: {
      slug: 'jak-smazat-moje-data',
      title: 'Jak smazat moje data - GOAT Gamesture',
      description: 'Jak požádat o vymazání vašich osobních údajů zpracovávaných společností Gamesture'
    },
    bg: {
      slug: 'kak-da-iztriya-dannite-si',
      title: 'Как да изтрия данните си - GOAT Gamesture',
      description: 'Как да поискате изтриването на личните ви данни, обработвани от Gamesture'
    },
    nl: {
      slug: 'hoe-verwijder-ik-mijn-gegevens',
      title: 'Hoe verwijder ik mijn gegevens - GOAT Gamesture',
      description: 'Hoe u een verzoek tot verwijdering van uw persoonlijke gegevens verwerkt door Gamesture kunt indienen'
    }
  }
}
